<template lang="pug">
AuthorPublishBespoke(:key="fileName" v-bind="courseAndFirm")
</template>

<script setup lang="ts">
import AuthorPublishBespoke from './AuthorPublishBespoke.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const fileName = computed(() => useRoute().params.fileName as string);

const courseAndFirm = computed(() => {
  const [courseIdStr = '', firmCodeStr = ''] = fileName.value
    .split('_')
    .reverse();

  const courseId = Number(courseIdStr);
  const firmCode = firmCodeStr;

  return { courseId, firmCode };
});
</script>
